// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"a485c9d1","142":"87857a1b","290":"eef997bc","400":"266b141a"}[chunkId] + ".chunk.js";
};